"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_extras__and__services__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "433fd1b1-d95f-4a02-9828-6398d3c94d42",
    "data-name": "Extras_services_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 160,
    height: 160,
    rx: 80,
    ry: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174h0A80.23,80.23,0,0,1,16,95c0,.33,0,.66,0,1h0a80.24,80.24,0,0,0,80,80h0a80.24,80.24,0,0,0,80-80h0c0-.34,0-.67,0-1A80.23,80.23,0,0,1,96,174Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,144a4,4,0,0,1-4-4V52a4,4,0,0,1,8,0v88A4,4,0,0,1,96,144Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,100H52a4,4,0,0,1,0-8h88a4,4,0,0,1,0,8Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "extras-and-services-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "64613b74-70b3-4eea-93d7-774175577a23",
    "data-name": "Extras_and_Services_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "ead9b531-8598-4725-a264-131a4d2cebc4",
    "data-name": "Extras_services_ic_hi",
    width: 192,
    height: 192,
    xlinkHref: "#433fd1b1-d95f-4a02-9828-6398d3c94d42"
  })));
}

var _default = ic_extras__and__services__dark;
exports.default = _default;